<template>
    <base-section
    id="san-andres"
    >
      <v-container>
      <base-section-heading
      title="Welcome to San Andrés Island!"
      color="secondary"
      align="left"
      :toColor="true"
      >
      San Andrés Island is a beautiful Caribbean Island and a part of Colombia. San Andrés is located in the Caribbean Sea, and it is part of an archipelago that also includes Providencia and Santa Catalina islands. The island boasts pristine white sandy beaches, crystal-clear turquoise waters, and vibrant coral reefs. The marine biodiversity around the island is exceptional, making it a haven for snorkelers and divers. The culture of San Andrés is a unique blend of Colombian, Afro-Caribbean, and English influences, producing very particular music, cuisine, and island ‘s traditions San Andrés Island offers a perfect blend of natural beauty, cultural richness, and recreational opportunities, making it a sought-after destination for travellers seeking a Caribbean getaway with a Colombian twist.
<br><br>
<div
class="d-flex justify-center"
>
      <iframe
      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7284137123010514944?compact=1"
      height="800"
      width="500"
      frameborder="0"
      allowfullscreen=""
      allow="autoplay"
      title="San Andrés"
      >
    </iframe>
</div>
    </base-section-heading>
      </v-container>
    </base-section>
  </template>

  <script>
    export default {
      name: 'SanAndres',

      data: () => ({
        slides: [
          {
            src: require('@/images/venue/maceio04.jpg'),
          },
          {
            src: require('@/images/venue/maceio03.jpg'),
          },
          {
            src: require('@/images/venue/maceio02.jpg'),
          },
          {
            src: require('@/images/venue/maceio01.jpg'),
          },
        ],
      }),
    }
  </script>

  <style>
  .v-application .grey--text.text--darken-1 {
    color: black !important;
  }
  </style>
